import axios from 'axios';

/**
 * Auth Service
 * @param {MainWrapper} callingClass
 */

export function getAPIBaseURL() {
  var URL = window.location.href;
  if (URL.includes('dev') || URL.includes('localhost')) {
    return `https://apidev.parker.com/dev`;
  } else if (URL.includes('test')) {
    return `https://apidev.parker.com/test`;
  } else if (URL.includes('preview')) {
    return `https://api.parker.com/stage`;
  } else {
    return `https://api.parker.com/prod`;
  }
}

export function getVarificationUrl() {
  if (
    window.location.hostname.toLowerCase().indexOf('localhost') >= 0 ||
    window.location.hostname.toLowerCase().indexOf('seddev') >= 0
  ) {
    return `https://logintest.parker.com/api/v1/sessions/me`;
  } else if (
    window.location.origin.indexOf('sedtest.') > 0 ||
    window.location.origin.indexOf('directorytest.') > 0
  ) {
    return `https://loginqa.parker.com/api/v1/sessions/me`;
  } else if (window.location.origin.indexOf('sedpreview.') > 0 > 0) {
    return `https://loginstage.parker.com/api/v1/sessions/me`;
  } else if (
    window.location.origin.indexOf('sed.') > 0 ||
    window.location.origin.indexOf('directory.') > 0
  ) {
    return `https://login.parker.com/api/v1/sessions/me`;
  } else {
    return `https://loginqa.parker.com/api/v1/sessions/me`;
  }
}
export async function varification() {
  let res = await axios(getVarificationUrl(), {
    method: 'GET',
    withCredentials: true
  })
    .then(function (result) {
      let response = result.data;
      window.sessionStorage.setItem('oktaSessionMeId', response.id);
      //window.sessionStorage.setItem( 'oktaSessionMeId',  '1021OiSMhTkSCmAPhI01Rr-Bg');
    })
    .catch(function (error) {
      console.log(error);
      window.sessionStorage.removeItem('oktaSessionMeId');
    });
  return res;
}

export function getAPIKey() {
  var URL = window.location.href;
  if (URL.includes('dev') || URL.includes('localhost')) {
    return `786ac6edd2444f53a6e2ed8757709baa`;
  } else if (URL.includes('test')) {
    return `d152a1b2df3343df870bd7d81df4124f`;
  } else if (URL.includes('preview')) {
    return `65a90ff0e998468da0cc80bb7736d8ea`;
  } else {
    return `fb5ccb2dedf54509900c5d96a24718c6`;
  }
}

export function getGreylockAPIBaseURL() {
  var URL = window.location.href;
  if (URL.includes('dev') || URL.includes('localhost')) {
    return 'https://apidev.parker.com/dev';
  } else if (URL.includes('test')) {
    return 'https://apidev.parker.com/test';
  } else if (URL.includes('preview')) {
    return 'https://apidev.parker.com/test';
  } else {
    return 'https://api.parker.com/prod';
  }
}

export function getGreylockAPIKey() {
  var URL = window.location.href;
  if (URL.includes('dev') || URL.includes('localhost')) {
    return '786ac6edd2444f53a6e2ed8757709baa';
  } else if (URL.includes('test')) {
    return 'd152a1b2df3343df870bd7d81df4124f';
  } else if (URL.includes('preview')) {
    return 'd152a1b2df3343df870bd7d81df4124f';
  } else {
    return 'fb5ccb2dedf54509900c5d96a24718c6';
  }
}

export function getWCSDomainBaseURL() {
  var URL = window.location.href;
  if (URL.includes('dev') || URL.includes('localhost')) {
    return 'https://phtest.parker.com';
  } else if (URL.includes('test')) {
    return 'https://phtest.parker.com';
  } else if (URL.includes('preview')) {
    return 'https://phstage.parker.com';
  } else {
    return 'https://ph.parker.com';
  }
}
